/* // Theme
import Theme from './includes/theme-toggle.js';
const siteTheme = new Theme(); */

import './includes/scroll-detection.js';
import './includes/page-transitions.js';
import './includes/browser-resize.js';
// import './includes/main-menu.js';
/* import './includes/video-popup.js'; */
/* import './includes/show-password.js'; */
// import './includes/handle-hash.js';
/* import './includes/countdown.js'; */
import './includes/reading-bar.js';
/* import './includes/assessment-form.js'; */
/* import './includes/tabs.js'; */

// Panels
/* import Panel from './includes/panels.js';
window.Panel = Panel;
const siteNav = new Panel('siteNav', false);
const searchPanel = new Panel('search');
const reel = new Panel('matchstic-reel');
if (document.querySelector('dialog#filters')) {
	const filters = new Panel('filters');
} */

// Animate elements when they reach the viewport, according to data- attributes.
import { Animasection } from './components/Animasection.js';
// Expose globally so we can call it again after Sprig refreshes things
window.Animasection = Animasection;
const animateSections = new Animasection();
animateSections.observeAll();

// Accordion - animating <details> & <summary>
/* import './components/Accordion.js'; */

// ----------------------------------------------------------------------
// Swiper (set up with v11.1.9)
// ----------------------------------------------------------------------
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

// Make Swiper & modules available to inline scripts
window.Swiper = Swiper;
window.Autoplay = Autoplay;
window.EffectFade = EffectFade;
window.Navigation = Navigation;
window.Pagination = Pagination;


// Toggle switches
// import './components/Toggle.js'